
if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");

        if (this.form) {
          this.form.addEventListener(
            "submit",
            this.onSubmitHandler.bind(this)
          );
        }

        this.cartNotification = document.querySelector("cart-notification");
        this.cartItems = document.querySelector("cart-items");
        this.quickViewWarpper = document.getElementById("quickViewWrapper");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      getSectionIds() {
  const ids = [];

  if (this.cartNotification) {
    this.cartNotification.getSectionsToRender().forEach((section) => {
      if (section.id) ids.push(section.id);
    });
  }

  if (this.cartItems) {
    this.cartItems.getSectionsToRender().forEach((section) => {
      if (section.section) ids.push(section.section);
    });
  }

  ids.push("cart-icon-bubble");

  return [...new Set(ids)];
}

      updateCartIconBubble(html) {
        if (!html) return;

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        const newBubble = doc.querySelector("#cart-icon-bubble");
        const oldBubble = document.querySelector("#cart-icon-bubble");

        if (newBubble && oldBubble) {
          oldBubble.replaceWith(newBubble);
        }
      }

      async refreshCartIconBubble() {
        try {
          const response = await fetch(
            `${window.location.pathname}?sections=cart-icon-bubble`,
            {
              headers: {
                "X-Requested-With": "XMLHttpRequest"
              }
            }
          );

          if (!response.ok) return;

          const sections = await response.json();

          this.updateCartIconBubble(sections["cart-icon-bubble"]);
        } catch (error) {
          console.error("Cart badge refresh error:", error);
        }
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        if (!this.form) return;

        const submitButton = this.querySelector('[type="submit"]');

        if (!submitButton || submitButton.disabled) return;

        submitButton.disabled = true;
        submitButton.classList.add("loading");

        try {
          const config = fetchConfig("javascript");

          config.headers["X-Requested-With"] = "XMLHttpRequest";
          delete config.headers["Content-Type"];

          const formData = new FormData(this.form);

          // Request all required sections in a single parameter.
          formData.set("sections", this.getSectionIds().join(","));
          formData.set("sections_url", window.location.pathname);

          config.body = formData;

          const response = await fetch(routes.cart_add_url, config);
          const parsedState = await response.json();
          console.log("ADD TO CART RESPONSE:", parsedState);
console.log("RETURNED SECTIONS:", parsedState.sections);

          if (!response.ok || parsedState.status) {
            this.handleErrorMessage(
              parsedState.description || "Unable to add product to cart."
            );
            return;
          }

          // Refresh the custom cart drawer.
          if (this.cartNotification) {
            this.cartNotification.renderContents(parsedState);
          }

          // Refresh the theme's standard cart drawer, if present.
          if (this.cartItems) {
            this.cartItems.renderContents(parsedState);
          }

          // Immediately replace the header badge with Shopify's HTML.
          if (
            parsedState.sections &&
            parsedState.sections["cart-icon-bubble"]
          ) {
            this.updateCartIconBubble(
              parsedState.sections["cart-icon-bubble"]
            );
          } else {
            await this.refreshCartIconBubble();
          }

          document
            .querySelector(".product-form__error-message-wrapper")
            ?.classList.add("no-js-inline");

        } catch (error) {
          console.error("Add to cart error:", error);
          this.handleErrorMessage(
            "Unable to add product. Please try again."
          );
        } finally {
          submitButton.classList.remove("loading");
          submitButton.disabled = false;

          this.quickViewWarpper?.classList.remove("show__modal");
          document.body.classList.remove("overflow-hidden");
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
          this.errorMessageWrapper.classList.remove("no-js-inline");
        }
      }
    }
  );
}
